import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreviewModalService {

  // Observable source
  private openSource = new Subject<PreviewData>();
  // Observable stream
  openedSource = this.openSource.asObservable();

  openModal(item: any, items: any[]) {
    this.openSource.next({ item, items });
  }
}

export interface PreviewData {
  item: any;
  items: any[];
}
